import * as actionTypes from "../Constants/ProcessActionTypes";
import { COUNTRIES, SNACKBAR_INIT_VALUE } from "../Constants";

const initialState = {
  loading: false,
  overlayOpen: false,
  primaryColor: "#155E98",
  searchableProducts: [],
  hasRecurringProduct: false,
  userDetails: null,
  countries: COUNTRIES,

  step: 1,

  formErrors: {
    firstName: { hasError: false },
    lastName: { hasError: false },
    email: { hasError: false },
    number: { hasError: false },
    country: { hasError: false },
    username: { hasError: false },
    password: { hasError: false },
    passwordConfirm: { hasError: false },
    street: { hasError: false },
    address: { hasError: false },
    suburb: { hasError: false },
    state: { hasError: false },
    postalCode: { hasError: false },
    day: { hasError: false },
    month: { hasError: false },
    year: { hasError: false },
    hasTraded: { hasError: false },
    tradedProducts: { hasError: false },
    tradeFrequency: { hasError: false },
    broker: { hasError: false },
    hearAboutUs: { hasError: false },
  },

  discount: null,

  snackbar: SNACKBAR_INIT_VALUE

};

const process = (state = initialState, { type, payload, duration }) => {
  switch (type) {
    case actionTypes.SET_LOADING:
      return { ...state, loading: payload };

    case actionTypes.SET_OVERLAY:
      return { ...state, overlayOpen: payload };

    case actionTypes.SET_PAYMENT_TYPE:
      return { ...state, paymentType: payload };

    case actionTypes.OPEN_SNACK_BAR:
      const { type: toastType, message: toastMessage, duration: toastDuration } = payload;
      return { ...state, snackbar: { ...state.snackbar, open: true, type: toastType, message: toastMessage, duration: toastDuration } };

    case actionTypes.CLOSE_SNACK_BAR:
      return { ...state, snackbar: { ...state.snackbar, open: false } };

    case actionTypes.SET_SEARCHABLE_PRODUCTS:
      return { ...state, searchableProducts: payload };

    case actionTypes.TOGGLE_PRIMARY_COLOR:
      return { ...state, primaryColor: state.primaryColor === "#155E98" ? "#151515" : "#155E98" };

    case actionTypes.SET_STEP:
      return { ...state, step: payload };

    case actionTypes.NEXT_STEP:
      let nextStep = state.step + 1;
      if (nextStep > 3) nextStep = 3;
      return { ...state, step: nextStep };

    case actionTypes.PREV_STEP:
      let prevStep = state.step - 1;
      if (prevStep < 0) prevStep = 0;
      return { ...state, step: prevStep };

    case actionTypes.SET_GLOBAL_VARIABLES:

      return { ...state };

    case actionTypes.SET_FORM_ERRORS:
      return { ...state, formErrors: payload };

    case actionTypes.UPDATE_FORM_ERROR:
      let { key: k, error } = payload;
      return error === undefined ? state : { ...state, formErrors: { ...state.formErrors, [k]: { hasError: true, errorMessage: error } } };

    case actionTypes.SET_DISCOUNT:
      return { ...state, discount: payload };

    case actionTypes.REMOVE_DISCOUNT:
      return { ...state, discount: null };

    default:
      return state;
  }
}

export default process;